export { default } from "./InfiniteCollection";
